module.exports = __webpack_public_path__ + "img/gssb2x.1adcda56.png";